<!-- CaseRefWindow -->
<template>
  <section id="caseref-window">
    <header id="caseref-window-header">
      <h2>판례 전문</h2>
      <button @click="$emit('closeWindow')" class="btn-close">X</button>
    </header>
    <!-- <article v-if="isFirst" class="caseref-box"></article> -->
    <article v-if="!caseRef['사건번호']" class="caseref-box">
      <div class="warning">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100"
          height="100"
          viewBox="0 0 24 24"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="gray"
            stroke-width="2"
            fill="white"
          />
          <text
            x="50%"
            y="50%"
            text-anchor="middle"
            fill="gray"
            font-size="18"
            font-family="Arial"
            dy=".3em"
          >
            !
          </text>
        </svg>
        <p>DB에 해당 판례가 없습니다.</p>
      </div>
    </article>
    <!-- Optional: 판시사항, 판결요지, 참조조문, 참조판례, 판사명 -->
    <article v-else id="caseref-box" class="caseref-box" ref="caserefBox">
      <div>
        <h3>{{ caseRef['법원명'] }} {{ caseRef['사건번호'] }}</h3>
      </div>
      <hr />
      <div>
        <h3>선고일자</h3>
        <p>{{ caseRef['선고일자'] }}</p>
      </div>
      <hr />
      <div>
        <h3>판시사항</h3>
        <p>{{ caseRef['판시사항'] || '없음' }}</p>
      </div>
      <hr />
      <div>
        <h3>판결요지</h3>
        <p>{{ caseRef['판결요지'] || '없음' }}</p>
      </div>
      <hr />
      <div>
        <h3>판례전문</h3>
        <p>{{ caseRef['판례전문'] }}</p>
      </div>
      <div>
        <p>{{ caseRef['판사명'] || '' }}</p>
      </div>
      <hr />
      <div>
        <h3>참조조문</h3>
        <p>{{ caseRef['참조조문'] || '없음' }}</p>
      </div>
      <hr />
      <div>
        <h3>참조판례</h3>
        <p>{{ caseRef['참조판례'] || '없음' }}</p>
      </div>
    </article>
    <footer id="caseref-window-footer"></footer>
  </section>
</template>

<script>
export default {
  /** 참조판례 : { 판례주제: string, 사건번호: String, 법원명: string, 선고일자: string, 판시사항: string, 판결요지: string, \
   *               참조조문: string, 참조판례: string, 주문: string, 판례전문: string, 판사명: string} */
  props: {
    caseRef: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      isFirst: true,
      fields: [
        ['법원명', '사건번호'],
        '선고일자',
        '판시사항',
        '판결요지',
        ['판례전문', '판사명'],
        '참조조문',
        '참조판례',
      ],
    };
  },
  watch: {
    caseRef: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          if (!this.$refs.caserefBox) return;
          this.$refs.caserefBox.scrollTo({ top: 0, behavior: 'smooth' });
        });
      },
    },
  },
};
</script>

<style scoped>
#caseref-window {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 600px;
  box-shadow: lightgray 0 0 10px 0;
  background: white;
}
#caseref-window-header {
  width: 100%;
  height: 50px;
  flex-shrink: 0;
  text-align: center;
  position: relative;
  border-bottom: 1px solid lightgray;
}
#caseref-window-header h2 {
  line-height: 50px;
  font-size: 25px;
  z-index: 1;
}
.caseref-box {
  width: 90%;
  margin-top: 5px;
  flex-grow: 1;
  padding: 5px 10px;
  overflow-y: scroll;
  line-height: 1.8rem;
}
.caseref-box div {
  width: 100%;
  margin: 10px 0px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break: break-all;
}
.caseref-box p {
  margin-top: 10px;
}
#caseref-window-footer {
  width: 100%;
  height: 20px;
  flex-shrink: 0;
}
.warning {
  margin: 0 auto;
  text-align: center;
}
.btn-close {
  border: 1px solid lightgray;
  border-radius: 5px;
  font-size: 20px;
  width: 30px;
  height: 30px;
  background-color: transparent;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 3;
}
.btn-close:hover {
  background-color: lightgray;
}
.btn-close:active {
  background-color: gray;
}

@media screen and (max-width: 1024px) {
  #caseref-window {
    position: absolute;
    right: 0;
    top: 0;
    min-width: 320px;
    max-width: 768px;
    width: 80%;
    height: 100%;
    z-index: 3;
  }
}
</style>
